import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import plusButton from '../../_static/images/plusButton.svg'
import plusButtonActiveIcon from '../../_static/images/plusButtonActive.svg'
import minusButtonIcon from '../../_static/images/minusButton.svg'
import minusButtonActiveIcon from '../../_static/images/minusButtonActive.svg'
import editButtonIcon from '../../_static/images/editButton.svg'
import editButtonActiveIcon from '../../_static/images/editButtonActive.svg'
import cn from 'classnames'
import {handleSetTutorialStep, tutorialModeSelector} from '../../modules/tutorial'


class ButtonPanel extends Component {
    render() {
        const {handleAddCreateClick, handleDeleteClick, isCreateActive = true, handleUpdateClick, isUpdateActive, isDeleteActive, toggleIcon : { shouldRender, isOpen, toggleOpen } = {}} = this.props
        const {formatMessage} = this.context

        return (
            <div className="qbm-accordion-action-panel">
                <div
                    onClick={handleAddCreateClick}
                    className="qbm-accordion-action-panel__action-button"
                    ref = {this.getPlusRef}
                >
                    <img
                        src={plusButtonActiveIcon}
                        src={isCreateActive ? plusButtonActiveIcon : plusButton}
                        alt={formatMessage("Add")}
                        title={formatMessage("Add")}
                    />
                </div>
                <div
                    onClick={handleDeleteClick}
                    className="qbm-accordion-action-panel__action-button"
                >
                    <img
                        src={isDeleteActive ? minusButtonActiveIcon : minusButtonIcon}
                        alt={formatMessage("Remove")}
                        title={formatMessage("Remove")}
                    />
                </div>
                <div
                    onClick={handleUpdateClick}
                    className="qbm-accordion-action-panel__action-button"
                >
                    <img
                        src={isUpdateActive ? editButtonActiveIcon : editButtonIcon}
                        alt={formatMessage("Edit")}
                        title={formatMessage("Edit")}
                    />
                </div>

                {
                    shouldRender && <div onClick={toggleOpen} className={cn("qbm-accordion-arrow ml-auto pointer", {open : isOpen})}></div>
                }
            </div>
        )
    }

    componentDidMount() {
        this.handleTutorial()
    }

    componentDidUpdate() {
        this.handleTutorial()
    }

    handleTutorial = () => {
        let {tooltips : {plus, step} = {}, handleSetTutorialStep, tutorialModeIsOn} = this.props
        if (tutorialModeIsOn && plus) {
            handleSetTutorialStep({
                step,
                container : this,
                target : this.plusRef
            })
        }
    }

    componentWillUnmount() {
        let {tooltips : {plus, step} = {}, handleSetTutorialStep} = this.props
        if (plus) {
            handleSetTutorialStep({
                step,
                container : null,
                target : null,
            })
        }
    }

    getPlusRef = ref => this.plusRef = ref

    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => ({
        tutorialModeIsOn : tutorialModeSelector(state),
    }),
    { handleSetTutorialStep }
)(ButtonPanel)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ButtonPanel.js